import { activeProductCriteria } from './activeProductCriteria.js';

export namespace Helpers {
  export const ActiveProductCriteria = activeProductCriteria();
}
